<template>
  <div ref="container">
    <a-affix :offsetTop="0">
      <a-page-header
        style="border-bottom: 1px solid rgb(235, 237, 240); background: #fff"
        class="mb-5 px-0"
        :title="$t('product.edit.title')"
        @back="() => $router.push({ name: 'catalogue.product.index' })"
      >
        <template slot="extra">
          <a-button type="primary" @click="$refs.form.submit()" :loading="saving">
            Update Product
          </a-button>
        </template>
      </a-page-header>
    </a-affix>

    <div>
      <ProductForm
        ref="form"
        hide-button
        :product="product"
        :discount="discount"
        @saved="saved"
      />
    </div>
  </div>
</template>

<script>
import ProductForm from '@/components/Product/Form/Index'

export default {
  name: 'EditCatalogue',
  components: {
    ProductForm,
  },
  data() {
    return {
      product: null,
      discount: null,
      loading: false,
    }
  },
  computed: {
    saving() {
      return this.$refs.form && this.$refs.form.saving
    },
  },
  methods: {
    saved(data) {
      window.scrollTo({ y: 0, x: 0 })
      return this.$notification.success({
        message: 'Update success',
        description: `Product ${data.title} has been updated`,
        duration: 5,
      })
    },
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler: function(val) {
        this.loading = true
        this.$store.dispatch('catalogue/getProduct', val)
          .then((data) => {
            this.product = data
            return this.$store.dispatch('catalogue/getDiscountList', val)
          })
          .then(({ data }) => {
            this.discount = data
          })
          .finally(() => {
            this.loading = false
          })
      },
    },
  },
}
</script>

<style>

</style>
